import { drama } from '../../../../constants/actionTypes';

export default (state = [], { type, commentId }) => {
  switch (type) {
    case drama.POST_DRAMA_REPLY:
      return [...state, commentId];

    case drama.POST_DRAMA_REPLY_SUCCESS:
    case drama.POST_DRAMA_REPLY_FAILED:
      return state.filter(id => id !== commentId);

    default:
      return state;
  }
};
